import {client} from './useClient'
import {permission} from './permission'
import {disableNumberWheel} from './disableNumberWheel'

const directives = {
    client,
    permission,
    disableNumberWheel
}
export default{
    install(Vue){
        Object.keys(directives).forEach((directive)=>{
            Vue.directive(directive,directives[directive])
        })
    }
}